<template>
  <div>
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header" class="clearfix">
        <span>表情配置</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="最小等级">
              <el-input v-model.number="emit.minLv" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="表情">
              <el-select v-model="emit.emoIds" style="width: 500px" multiple placeholder="请选择">
                <el-option
                  v-for="item in emitIcon"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="互动表情" />
            <el-form :inline="true">
              <el-row v-for="(item, index) in emit.interactEmoticon" :key="index">
                <el-form-item label="表情ID">
                  <el-input v-model.number="item.id" placeholder="表情ID" />
                </el-form-item>
                <el-form-item label="消耗类型">
                  <el-select v-model="item.prize[0].propsId" placeholder="请选择">
                    <el-option
                      v-for="item in propSimple"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="消耗数量">
                  <el-input v-model.number="item.prize[0].num" placeholder="消耗金币" />
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="del(index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button type="primary" @click="add">+</el-button>
            </el-form>
          </el-col>
        </el-row>
        <el-button style="margin-top: 10px;" type="primary" @click="onSubmit()">保存</el-button>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'Emot',
  data() {
    return {
      key: 'CLUB_CONFIG:EMOTICONS',
      emit: { 'minLv': 1, 'emoIds': [1, 2, 3, 4, 5, 6, 7],
        interactEmoticon: [
          { id: 0, prize: [{ propsId: 14, num: 0, skin: 0 }] }
        ]
      },
      propSimple: [
        { label: '金币', value: 14 },
        { label: '钻石', value: 22 },
        { label: '体力', value: 15 },
        { label: '野兽币', value: 65 }
      ],
      emitIcon: [
        { label: '拖鞋', value: 1 },
        { label: '爱心', value: 2 },
        { label: '花朵', value: 3 },
        { label: '早安', value: 4 },
        { label: '鸡蛋', value: 5 },
        { label: '西红柿', value: 6 },
        { label: '炸弹', value: 7 }
      ]

    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.emit = res.data
      })
    },
    onSubmit() {
      for (const i in this.emit.interactEmoticon) {
        const val = this.emit.interactEmoticon[i]
        if (val.prize[0].propsId === 65) {
          val.prize[0].num *= 10000
        }
        this.emit.interactEmoticon[i] = val
      }
      const data = JSON.stringify(this.emit)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.emit.interactEmoticon.push({ id: 0, prize: [{ propsId: 14, num: 0, skin: 0 }] })
    },
    del(index) {
      this.emit.interactEmoticon = this.emit.interactEmoticon.filter((item, idx) => {
        return idx !== index
      })
    }
  }
}
</script>

<style scoped>

</style>
